export enum BusinessUnitKey {
  Flokee = 'FLOKEE',
  Cleepo = 'CLEEPO',
}

export const DEFAULT_DASHBOARD_ROUTE_NAME = 'DashboardView';
export const DEFAULT_LOGIN_ROUTE_NAME = 'AuthLoginView';
export const DEFAULT_SELECT_ACCOUNT_ROUTE_NAME = 'SelectAccountView';
export const DEFAULT_INVEST_ROUTE_NAME = 'InvestView';

export interface BusinessUnitConfig {
  key: BusinessUnitKey;
  // Position in listings that show every product, e.g. the BU chooser.
  order: number;
  label: string;
  // Route prefix for this BU namespace (e.g. /flokee).
  basePath: string;
  // Production domain that implies this BU.
  domain?: string;
  // Route name to redirect authenticated users to this BU dashboard.
  dashboardRouteName: string;
  // Route name to redirect unauthenticated users to this BU login.
  loginRouteName: string;
  // Route name for account/order switcher view in this BU.
  selectAccountRouteName: string;
  // Route name for the BU invest page (free-plan redirect).
  investRouteName: string;
  // Help center URL for this BU (shown in sidebar support links when available).
  helpCenterUrl?: string;
  // Public product site for this BU, linked from the "About <product>" footer.
  // Branding, so it stays product-owned while support contacts moved to the
  // partner: the footer renders before login, when there is no account and so
  // no partner to read, and it must name the product the visitor is looking at
  // rather than whoever happens to answer its support line (FLOK-1661).
  websiteUrl: string;
  // Privacy policy URL for this BU. Product-owned for want of anywhere else:
  // FLOK-1648 gave the partner no privacy field, so there is nothing to read
  // (FLOK-1661). Flokee's own URL is still outstanding on FLOK-1644.
  privacyPolicyUrl: string;
  // Whether the BU requires a plan-subscription-approval modal before checkout.
  hasPlanSubscriptionApproval: boolean;
  // i18n key for the BU description on the chooser page.
  chooserDescriptionKey: string;
  /** i18n key prefix for cart plan selection (keys: .title, .description, .disclaimer). */
  cartSelectI18nPrefix: string;
  // Orbit entity kind for admin deep links.
  orbitEntityType: 'ecommerce' | 'project';
  // Orbit path template for admin deep links.
  orbitPathTemplate: string;
  // Shared UI assets resolved by BU.
  logoPath: string;
  faviconPath: string;
}
